export default "__VITE_ASSET__BEhFaWch__"